/* eslint-disable react/no-danger */
/* eslint-disable no-shadow */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { useHistory, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import SelectSearch, { fuzzySearch } from 'react-select-search';
import { FaLock } from 'react-icons/fa';
import H2 from '../../../../components/h2';
import P from '../../../../components/p';
import HR from '../../../../components/hr';
import Input from '../../../../components/input';
import Spacer from '../../../../components/spacer';
import InnerRadio from '../../../../components/innerRadio';
import ButtonInner from '../../../../components/buttonInner';
import ApiErrorMessage from '../../../../components/apiErrorMessage';
import AppState from '../../../../store/appstate';
import {
  getMyAccount,
  getMyWriter, getMyWriters, getSocieties, getTheme, whoAmI,
} from '../../../../api/queries';
import { createWriter, updateWriter } from '../../../../api/mutations';
import LoadingSmall from '../../../../components/loadingSmall';
import { nameRegexTest, sendEvent, sendProperty } from '../../../../helpers/helpers';
import ButtonPrimaryLarge from '../../../../components/buttonPrimaryLarge';
import ButtonPrimaryText from '../../../../components/buttonPrimaryText';
import H1 from '../../../../components/h1';

function WritersForm(props) {
  const { id, modal, closeModal } = props;

  const isUpdate = !!id;

  const selectedAccount = AppState.useState((s) => s.selectedAccount);

  const myAccount = getMyAccount({
    artistaccountcode: selectedAccount,
  });

  const theme = getTheme({
    cataloguecode: myAccount?.data?.cataloguecode,
  });

  const [firstName, setFirstName] = useState();
  const [middleName, setMiddleName] = useState();
  const [lastName, setLastName] = useState();
  const [proMember, setProMember] = useState(false);
  const [whichPRO, setWhichPRO] = useState(null);
  const [isLocked, setIsLocked] = useState(false);
  const [caeipiNumber, setCaeipiNumber] = useState();
  // eslint-disable-next-line no-unused-vars
  const [pending, setPending] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [apiError, setApiError] = useState('');
  const [errors, setErrors] = useState({});
  const [termsChecked, setTermsChecked] = useState(false);

  const societies = getSocieties();
  const history = useHistory();
  const createMutation = createWriter();
  const updateMutation = updateWriter();
  const who = whoAmI();

  const writers = getMyWriters({ aac: selectedAccount });
  const writer = getMyWriter({ aac: selectedAccount, wc: id });

  const { t } = useTranslation(['writers']);

  if (writer.isSuccess && id && !firstName) {
    setFirstName(writer.data.firstname);
    setMiddleName(writer.data.middlename);
    setLastName(writer.data.lastname);
    setProMember(writer.data.societycisaccode !== null);
    setWhichPRO(writer.data.societycisaccode);
    setCaeipiNumber(writer.data.caeipinumber);
    setIsLocked(writer.data.islocked);
  }

  useEffect(() => {
    if (selectedAccount) {
      writers.refetch();
      writer.refetch();
    }
  }, [selectedAccount]);

  if ((writer.isError || writer.data === null) && isUpdate) {
    history.push('/writers');
  }

  const checkErrors = () => {
    const errs = {};
    let valid = true;
    // first name check
    const validFirstName = firstName?.trim().length > 0;
    if (!validFirstName) {
      errs.firstName = t('regex:enter-first-name-check');
      valid = false;
    }

    if (!nameRegexTest(firstName)) {
      errs.firstName = t('regex:invalid-characters2');
      valid = false;
    }

    if (middleName && !nameRegexTest(middleName)) {
      errs.middleName = t('regex:invalid-characters2');
      valid = false;
    }

    // last name check
    const validLastName = lastName?.trim().length > 0;
    if (!validLastName) {
      errs.lastName = t('regex:enter-last-name-check');
      valid = false;
    }

    if (!nameRegexTest(lastName)) {
      errs.lastName = t('regex:invalid-characters2');
      valid = false;
    }

    if (!isUpdate && theme.data.show_writers_terms && !writers?.data?.writers.length > 0 && !termsChecked) {
      errs.terms = t('regex:terms-and-conditions-error');
      valid = false;
    }

    if (proMember === true) {
      // last name check
      const validcaeipiNumber = caeipiNumber?.trim().length > 0;
      if (!validcaeipiNumber) {
        errs.caeipiNumber = t('regex:cae-ipi-error');
        valid = false;
      }

      if (caeipiNumber?.trim().length < 9) {
        errs.caeipiNumber = t('regex:cae-ipi-regex');
        valid = false;
      }

      if (!whichPRO) {
        errs.whichPRO = t('regex:choose-an-organisation');
        valid = false;
      }
    }

    setErrors(errs);
    return valid;
  };

  const addWriter = async () => {
    setPending(true);
    setApiError('');
    // reset mutation
    createMutation.reset();
    const valid = checkErrors();
    if (valid) {
      const data = {
        artistaccountcode: selectedAccount,
        firstname: firstName,
        middlename: middleName,
        lastname: lastName,
        societycisaccode: proMember === true ? whichPRO : '',
        caeipinumber: proMember === true ? caeipiNumber : '',
        publishername: '',
        publishercaeipi: '',
        isunknownwriter: false,
      };

      createMutation.mutate(data, {
        onSuccess: (response) => {
          if (response.validationMessage) {
            setApiError(response.validationMessage);
            setPending(false);
          } else {
            toast.success(`${t('writers:writer-added-toast')}: ${firstName} ${lastName}`, {
              position: 'bottom-right',
              autoClose: 5000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
            });
            writers.refetch();
            setPending(false);
            sendProperty({ property: 'last_writer_added', value: 'CURRENT_DATE', email: who?.data?.email });
            sendEvent({ property: 'pe14489857_writer_added' });
            if (modal) {
              closeModal();
            } else {
              history.push('/writers');
            }
          }
        },
        onError: (error) => {
          setApiError(error.message);
          setPending(false);
        },
      });
    } else {
      setPending(false);
    }
  };

  const update = async () => {
    setPending(true);
    setApiError('');
    // reset mutation
    updateMutation.reset();
    const valid = checkErrors();
    if (valid) {
      const data = {
        artistaccountcode: selectedAccount,
        writercode: id,
        firstname: firstName,
        middlename: middleName,
        lastname: lastName,
        societycisaccode: proMember === true ? whichPRO : '',
        caeipinumber: proMember === true ? caeipiNumber : '',
        publishername: '',
        publishercaeipi: '',
        etag: writer.data.etag,
      };

      updateMutation.mutate(data, {
        onSuccess: () => {
          toast.success(`${t('writers:writer-updated-toast')}: ${firstName} ${lastName}`, {
            position: 'bottom-right',
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          });
          writer.refetch();
          writers.refetch();
          if (modal) {
            closeModal();
          } else {
            history.push('/writers');
          }
          setPending(false);
        },
        onError: (error) => {
          setApiError(error.message);
          setPending(false);
        },
      });
    } else {
      setPending(false);
    }
  };
  return (
    <>

      <div className={`${modal ? '' : 'lg:min-h-screen-minus-header'} px-2 max-w-3xl`}>
        {(!id || (id && writer.isSuccess))
          && (
            <>
              <H1>
                {isUpdate ? (
                  <span>
                    {isLocked
                      && <FaLock className="inline" />}
                    {' '}
                    {t('writers:update-header')}
                    {' '}
                    <b>
                      {writer?.data?.firstname}
                      {' '}

                    </b>

                  </span>
                ) : t('writers:create-new-writer')}
              </H1>
              {!isUpdate
                && (
                  <>
                    <Spacer thin />
                    <ButtonPrimaryText id="btnWriterFormCancel" onClick={() => history.push('/writers')}>
                      {t('writers:cancel-and-return-writers-list')}
                    </ButtonPrimaryText>
                    <Spacer />
                  </>
                )}
              <div className={`${modal ? 'w-full' : 'w-full lg:w-2/3'}`}>
                <small>{t('writers:legal-name-explanation')}</small>
                <Spacer thin />
                <Input
                  id="txtWriterFormName"
                  required
                  type="text"
                  error={errors.firstName}
                  placeholder={t('auth:first-name')}
                  value={firstName}
                  onBlur={() => { }}
                  onChange={(e) => {
                    setFirstName(e.target.value);
                  }}
                />
                <Spacer thin />
                <Input
                  id="txtWriterFormMiddleName"
                  type="text"
                  error={errors.middleName}
                  placeholder={t('auth:middle-name')}
                  value={middleName}
                  onBlur={() => { }}
                  onChange={(e) => {
                    setMiddleName(e.target.value);
                  }}
                />
                <Spacer thin />
                <Input
                  id="txtWriterFormLastName"
                  required
                  type="text"
                  error={errors.lastName}
                  placeholder={t('auth:last-name')}
                  value={lastName}
                  onBlur={() => { }}
                  onChange={(e) => {
                    setLastName(e.target.value);
                  }}
                />

                <Spacer />

                <InnerRadio
                  name="proMember"
                  label={t('writers:is-writer-pro-member-confirm')}
                  value={proMember}
                  onChange={(e) => setProMember(e.target.value === 'true')}
                  options={[
                    { label: t('common:yes'), value: true },
                    { label: t('common:no'), value: false },
                  ]}
                />

                {proMember === true && societies.isSuccess && societies?.data?.societies.length > 0 && (
                  <>
                    <Spacer thin />
                    <div className="w-full">
                      <SelectSearch
                        id="txtWriterFormChooseOrg"
                        options={societies.data.societies.map((p) => ({ name: p.name, value: p.cisaccode }))}
                        onChange={(add) => {
                          setWhichPRO(add);
                        }}
                        value={whichPRO}
                        className="select-search select-search--multiple text-sentric-dark-gray required-star"
                        search
                        filterOptions={fuzzySearch}
                        placeholder={t('writers:choose-organisation-placeholder')}
                      />
                      {!!errors.whichPRO
                        && <p className="w-4/5 error-arrow-top text-sm inline-block p-1 pr-3 pl-3 bg-red-700 mt-2 text-white rounded-lg border-white border">{errors.whichPRO}</p>}
                    </div>

                    <Spacer thin />
                    <Input
                      id="txtWriterFormCAENumber"
                      required
                      type="text"
                      maxLength={11}
                      error={errors.caeipiNumber}
                      placeholder={t('writers:cae-ipi-number-placeholder')}
                      value={caeipiNumber}
                      onBlur={() => { }}
                      onChange={(e) => {
                        setCaeipiNumber(e.target.value);
                      }}
                    />
                  </>
                )}

                <Spacer />
                <HR />
                <Spacer />
                {!isUpdate && !writers?.data?.writers.length > 0 && theme.data.show_writers_terms
                  && (
                    <div>
                      <h2 className="font-semibold text-xl">
                        {t('common:terms')}
                        {' '}
                        &amp;
                        {' '}
                        {t('common:conditions')}
                      </h2>

                      <div className="overflow-y-auto h-64 p-4 mt-4 mb-8 rounded bg-sentric-content-white">
                        <div
                          className="html-content"
                          dangerouslySetInnerHTML={{ __html: theme.data.writers_terms }}
                        />

                      </div>
                      <div>
                        <label className="" htmlFor="terms">
                          <input
                            type="checkbox"
                            id="terms"
                            name="terms"
                            value={termsChecked}
                            className="mr-4"
                            onChange={(e) => setTermsChecked(!termsChecked)}
                          />
                          {t('writers:i-have-read-terms-and-conditions')}

                        </label>
                      </div>
                      {!!errors.terms
                        && <p className="w-4/5 error-arrow-top text-sm inline-block p-1 pr-3 pl-3 bg-red-700 mt-2 text-white rounded-lg border-white border">{errors.terms}</p>}
                      <Spacer />
                      <HR />
                      <Spacer />
                    </div>
                  )}

                <ApiErrorMessage apiError={apiError} />
                <div className="flex flex-col justify-center items-center">
                  {!isUpdate
                    && <ButtonPrimaryLarge id="btnWriterFormAdd" onClick={addWriter} disabled={pending} pending={pending}>{t('writers:add-writer-button')}</ButtonPrimaryLarge>}
                  {isUpdate
                    && (
                      <ButtonPrimaryLarge id="btnWriterFormUpdate" onClick={update} disabled={pending || isLocked} pending={pending}>
                        {' '}
                        {isLocked
                          && (
                            <>
                              <FaLock className="inline" />
                              {' '}
                            </>
                          )}
                        {t('writers:update-writer-button')}
                      </ButtonPrimaryLarge>
                    )}
                  {modal
                    && (
                      <div className="mt-4">
                        <ButtonPrimaryText id="btnWriterFormClose" onClick={() => closeModal()}>
                          {t('writers:cancel-and-close')}
                        </ButtonPrimaryText>
                      </div>
                    )}
                </div>
              </div>
            </>
          )}
        {id && writer.isLoading
          && <LoadingSmall />}
      </div>

    </>
  );
}
export default WritersForm;
